import { Component, inject, input } from "@angular/core";
import { Router } from "@angular/router";
import { finalize } from "rxjs";

import { AuthModel, EXPLICIT_SELECT_ORGANISATION } from "@intocare/auth-data";

@Component({
	selector: "ic-problem",
	templateUrl: "./problem.component.html",
	standalone: false,
})
export class ProblemComponent {
	private router = inject(Router);
	private authModel = inject(AuthModel);
	labelKey = input.required<string>();

	goToLogin() {
		this.authModel
			.logOut(false, { redirect: false })
			.pipe(
				finalize(() => {
					this.router
						.navigate(["select-organisation"], { state: { [EXPLICIT_SELECT_ORGANISATION]: true } })
						.then(() => document.location.reload());
				}),
			)
			.subscribe();
	}
}
